import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const DumbbellIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.white.primary,
    ...rest
  } = props;

  return (
    <Svg
      enable-background={'new 0 0 566.93 566.93'}
      viewBox={'0 0 566.93 566.93'}
      width={width}
      height={height}
      {...rest}
    >
      <Path
        fill={color}
        d={
          'm441.7 113.4c19.9 0 36 16.1 36 36v234c0 19.9-16.1 36-36 36s-36-16.1-36-36v-90h-242.9v90c0 19.9-16.1 36-36 36s-36-16.1-36-36v-234c0-19.9 16.1-36 36-36s36 16.1 36 36v90h242.9v-90c0-19.9 16.1-36 36-36zm-382.5 54c12.4 0 22.5 10.1 22.5 22.5v153c0 12.4-10.1 22.5-22.5 22.5s-22.5-10.1-22.5-22.5v-153c0-12.4 10.1-22.5 22.5-22.5zm450 0c12.4 0 22.5 10.1 22.5 22.5v153c0 12.4-10.1 22.5-22.5 22.5s-22.5-10.1-22.5-22.5v-153c0-12.4 10.1-22.5 22.5-22.5zm-495 54c7.5 0 13.5 6 13.5 13.5v63c0 7.5-6 13.5-13.5 13.5s-13.5-6-13.5-13.5v-63c0.1-7.5 6.1-13.5 13.5-13.5zm540 0c7.5 0 13.5 6 13.5 13.5v63c0 7.5-6 13.5-13.5 13.5s-13.5-6-13.5-13.5v-63c0-7.5 6-13.5 13.5-13.5z'
        }
      />
    </Svg>
  );
};

export default DumbbellIcon;
